"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _useThemeDefaultProps = _interopRequireDefault(require("./useThemeDefaultProps"));

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-types */
// import PropTypes from 'prop-types';
var withThemeProps = function withThemeProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        name = options.name;

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withThemeProps()(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithThemeProps = /*#__PURE__*/_react.default.forwardRef(function WithThemeProps(props, ref) {
      var more = (0, _useThemeDefaultProps.default)(name, props, defaultTheme);
      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
        ref: ref
      }, more));
    });

    process.env.NODE_ENV !== "production" ? WithThemeProps.propTypes = {} : void 0;
    WithThemeProps.defaultProps = {};

    if (process.env.NODE_ENV !== 'production') {
      WithThemeProps.displayName = "WithThemeProps(".concat(Component.displayName || Component.name || 'Component', ")");
    }

    (0, _hoistNonReactStatics.default)(WithThemeProps, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      // @ts-ignore
      WithThemeProps.Naked = Component; // @ts-ignore

      WithThemeProps.options = options;
    }

    return WithThemeProps;
  };
};

var _default = withThemeProps;
exports.default = _default;